<template>
<div class="rank-zone">
  <div class="container">
      <advanced-filters v-if="showAdvancedFilters"
        class="rank-zone__advanced"
        :options="advancedOptions" 
        :predefinedOptions="_advancedFilters" 
        copyPage
        :exportEnabled="showExportButton"
        @share="copyFilters" 
        @export="exportCsv"
        @apply-advanced="applyAdvancedOptions" />
  </div>
<!--  <keep-alive>-->
    <router-view :selectedAdvancedOptions="selectedAdvancedOptions" @export-disable="disableExport" ref="child" ></router-view>
<!--  </keep-alive>-->
</div>
</template>

<script>
import { mapState } from 'vuex'
import {
  addOptionsToConfig,
  ADVANCED_OPTION_TYPE,
  competitionFieldsConfig,
  urlFieldsConfig,
  progressFieldsConfig,
  statusFieldsConfig,
  sectionFieldsConfig,
} from '@/features/reports/common/advanced-options/config'
import AdvancedFilters from '@/features/reports/common/advanced-filters/AdvancedFilters'
import { advancedFiltersMixins } from '@/features/reports/common/AdvancedFiltersMixins'
import _ from 'lodash'

const linkTypes = new Map([
  ['Comparison', 'comparison'],
  ['Sections', 'section'],
  ['Status', 'status'],
  ['URL', 'url']
])
const ROUTES = ['Competition', 'Overview', 'Progress', 'Sections', 'Status', 'Url']
const ADVANCED_OPTIONS_CONFIG = {
  progress: progressFieldsConfig,
  comparison: competitionFieldsConfig,
  sections: sectionFieldsConfig,
  status: statusFieldsConfig,
  url: urlFieldsConfig
}

export default {
  name: 'RankZone',
  mixins: [advancedFiltersMixins],
  components: { AdvancedFilters },
  created () {
    if (this._advancedFilters) {
      try {
        const advancedFilters = JSON.parse(this._advancedFilters)
        this.selectedAdvancedOptions = advancedFilters.filters.map((item, index) => {
          const option = this.advancedOptions.find(opt => opt.type === item.selectedField)
          const isFirst = index === 0
          const id = Date.now().valueOf() + index // to avoid coincidence of ids
          return {
            ...option, ...item, isFirst, id
          }
        })
      } catch (e) {
        console.error(e)
      }
    }
  },
  data () {
    return {
      isExportDisabled: true,
      includedRoutes: ROUTES,
      selectedAdvancedOptions: [],
      advancedOptionsConfig: ADVANCED_OPTIONS_CONFIG
    }
  },
  computed: {
    ...mapState({
      selectedClient: 'selectedClient'
    }),
    ...mapState('rankZoneCommon', {
      optionsToConfig: state => ({
        sections: state.sections,
        attributes: state.attributes,
        urlStatuses: state.urlStatuses,
        pageTypes: state.pageTypes,
        scores: state.scores,
        isOptimized: state.isOptimized,
        urlAttributes: state.urlAttributes,
        serpFeature: state.serpFeature,
        contentBriefStatuses: state.contentBriefStatuses,
        mismatchedUrls: state.mismatchedUrls,
        mappedUrls: state.mappedUrls
      })
    }),
    showAdvancedFilters () {
      return !(this.$route.name.toLocaleLowerCase() === 'overview')
    },
    advancedOptions () {
      const page = this.$route.name.toLocaleLowerCase()
      let config = _.cloneDeep(this.advancedOptionsConfig[page])
      addOptionsToConfig(config, this.optionsToConfig.sections, ADVANCED_OPTION_TYPE.SECTION)
      addOptionsToConfig(config, this.optionsToConfig.attributes, ADVANCED_OPTION_TYPE.ATTRIBUTE)
      addOptionsToConfig(config, this.optionsToConfig.urlStatuses, ADVANCED_OPTION_TYPE.URL_STATUS)
      addOptionsToConfig(config, this.optionsToConfig.pageTypes, ADVANCED_OPTION_TYPE.PAGE_TYPE)
      addOptionsToConfig(config, this.optionsToConfig.scores, ADVANCED_OPTION_TYPE.SCORE)
      addOptionsToConfig(config, this.optionsToConfig.isOptimized, ADVANCED_OPTION_TYPE.IS_OPTIMIZED)
      addOptionsToConfig(config, this.optionsToConfig.urlAttributes, ADVANCED_OPTION_TYPE.URL_ATTRIBUTE)
      addOptionsToConfig(config, this.optionsToConfig.serpFeature, ADVANCED_OPTION_TYPE.SERP_FEATURE)
      addOptionsToConfig(config, this.optionsToConfig.contentBriefStatuses, ADVANCED_OPTION_TYPE.CONTENT_BRIEF_STATUS)
      addOptionsToConfig(config, this.optionsToConfig.mappedUrls, ADVANCED_OPTION_TYPE.URL)
      page !== 'comparison' && addOptionsToConfig(config, this.optionsToConfig.mismatchedUrls, ADVANCED_OPTION_TYPE.MISMATCHED_URLS)
      return this.isClientDifficultyScoreEnabled ? config : config.filter(i => i.type !== ADVANCED_OPTION_TYPE.DIFF_SCORE)
    },
    showExportButton () {
      return this.selectedClient && this.$route.name !== 'Overview' && !this.isExportDisabled
    },
    getExportLink () {
      return this.selectedClient && `/rest/reports/rankzone-report/export/${this.clientId}?type=${linkTypes.get(this.$route.name)}`
    }
  },
  watch: {
    selectedClient (client) {
      if (!client) {
        return
      }
      this.includedRoutes = []
      if (this.isCurrentUserClientCollaborator) {
        this.$router.replace('/strategy/url-planner')
      }
      setTimeout(() => {
        this.includedRoutes = ROUTES
      }, 1000)
      // this.getSession({ clientId: this.selectedClient._id, isChanging: true })
    },
    '$route.name': {
      handler (value) {
        let selectedAdvancedOptions = _.cloneDeep(this.selectedAdvancedOptions)

        if (value.toLowerCase() === 'comparison') {
          selectedAdvancedOptions = selectedAdvancedOptions.filter(item => item.type !== ADVANCED_OPTION_TYPE.MISMATCHED_URLS)
        }

        const advancedOptions = selectedAdvancedOptions.map(item => {
          return {
            selectedField: item.selectedField,
            selectedFilter: item.selectedFilter,
            selectedOperator: item.selectedOperator
          }
        })
        const filters = JSON.stringify({ filters: advancedOptions })
        this._advancedFilters = filters
      }
    }
  },
  methods: {
    // ...mapActions('rankZoneCommon', [
    //   'getSession'
    // ]),
    exportCsv () {
      this.$refs.child.exportCsv()
    },
    /**
     * @param options - applied advanced options
     */
    async applyAdvancedOptions (options) {
      this.selectedAdvancedOptions = _.cloneDeep(options)
    },
    disableExport (disabled) {
      this.isExportDisabled = disabled
    }
  }
}
</script>

<style lang="scss">

  .rank-zone {
    min-width: 1200px;

    &__breadcrumb {
      height: 60px;
      margin-bottom: 80px;
      align-items: center;
      display: flex;
      border-bottom: 1px solid rgba(1, 22, 39, .1);
      padding-left: $rfx-wide-screen-side-gap;
      box-sizing: border-box;

      @media screen and (max-width: $rfx-wide-screen-width) {
        padding-left: $rfx-default-padding;
      }
    }

    &__export-link {
      position: absolute;
      right: 10px;
      top: 21px;
      z-index: 9;
      cursor: pointer;
      font-size: 20px;

      &_wrapper {
        position: relative;
        width: -webkit-fill-available;
        height: 0px;
      }
    }

    &__advanced {
      margin: 14px 0;

      &_shift-right {

        .collapsible__header {
          padding-right: 70px !important;
        }

        .collapsible__arrow {
          right: 46px !important;
        }
      }
    }

    .common-table__header-cell {
      background-color: $rfx-pale-grey;
      color: $rfx-dark-grey;
    }

    .common-table__row_highlighted {
      .common-table__cell {
        color: $rfx-light-blue !important;
      }
    }

    &__loader {
      display: flex;
      justify-content: center;
      align-items: center;
      height: calc(100vh - 530px)
    }

    &__no-data {
      display: flex;
      height: 300px;
      background-color: #fff;
      border-radius: $rfx-default-border-radius;
      align-items: center;
      justify-content: center;
      font-size: 27px;
      font-weight: 600;
      color: $rfx-medium-grey;
    }

    .table-wrapper {
      background-color: #fff;
      position: relative;
      display: flex;
      flex-direction: column;
      margin-bottom: 30px;
      border-radius: 4px;
      border: 1px solid rgba(1,22,39,.1);

      &__header {
        min-height: 60px;
        box-sizing: border-box;
        padding: 0 20px;
      }

      &__body {
        display: flex;
      }
    }

    .page-cover-loader {
      display: flex;
      position: fixed;
      top: 16px;
      left: 0;
      width: 100%;
      height: 100%;
      background: rgba(255, 255, 255, .5);
      align-items: center;
      justify-content: center;
      z-index: 99999;
    }
  }
</style>
